import { Reducer } from 'redux';

import {
  COMPANY_PROFILE_ANY_FAILED,
  COMPANY_PROFILE_ANY_REQUEST,
  GET_COMPANY_ANSWERS_SUCCESS,
  GET_COMPANY_QUESTIONS_IMPROVE_SUCCESS,
  GET_COMPANY_NEWS_SUCCESS,
  GET_COMPANY_QUESTIONS_SUCCESS,
  GET_COMPANY_TOPICS_SUCCESS,
} from '~src/modules/reports/companyProfile/constants/companyProfileActions';
import { ThunkFailAction, ThunkSuccessAction } from '~src/services/apiMiddleware';
import {
  defaultInitState,
  ProfileState,
  resultListToObject,
} from '~src/modules/reports/shared/distributers/actionDistributor';
import { ReportSubjectTypes } from '~src/modules/reports/interfaces/header.interface';

export function getInitialCompanyProfileState(): ProfileState {
  return { ...defaultInitState };
}

const companyProfileReducer: Reducer<ProfileState, ThunkSuccessAction | ThunkFailAction> = (
  state: ProfileState = getInitialCompanyProfileState(),
  action,
) => {
  switch (action.type) {
    case COMPANY_PROFILE_ANY_REQUEST: {
      return { ...state, loading: true };
    }
    case COMPANY_PROFILE_ANY_FAILED: {
      return { ...state, loading: false };
    }
    case GET_COMPANY_TOPICS_SUCCESS: {
      return {
        ...state,
        loading: false,
        topics: resultListToObject(ReportSubjectTypes.Topic, action.response.data),
      };
    }
    case GET_COMPANY_QUESTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        questions: resultListToObject(ReportSubjectTypes.Question, action.response.data),
      };
    }
    case GET_COMPANY_ANSWERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        answers: resultListToObject(ReportSubjectTypes.Answer, action.response.data),
      };
    }
    case GET_COMPANY_QUESTIONS_IMPROVE_SUCCESS: {
      return {
        ...state,
        loading: false,
        questions_improve: resultListToObject(ReportSubjectTypes.QuestionsImprove, action.response.data),
      };
    }
    case GET_COMPANY_NEWS_SUCCESS: {
      return {
        ...state,
        loading: false,
        news: resultListToObject(ReportSubjectTypes.News, action.response.data),
      };
    }
    default:
      return state;
  }
};

export default companyProfileReducer;
